export const DEMO_DATA_DASHBOARD_OVERVIEW_REACTIONS = [
  0, 23, 43, 43, 65, 66, 100
];
export const DEMO_DATA_DASHBOARD_OVERVIEW_IMPRESSIONS = [
  0, 50, 0, 35, 70, 200, 350
];

export const DEMO_DATA_DASHBOARD_PROFILE_VIEW_INSTAGRAM = [
  7, 3, 10, 9, 8, 16, 5
];

export const DEMO_DATA_DASHBOARD_PROFILE_VIEW_GOOGLE = [1, 4, 2, 5, 3, 1, 2];

export const DEMO_DATA_DASHBOARD_PROFILE_VIEW_LINKEDIN_BUSINESS_PAGE = [
  16, 0, 0, 0, 0, 4, 20
];

export const DEMO_DATA_DASHBOARD_POST_REACTIONS_LINKEDIN_BUSINESS_PAGE = [
  3, 2, 5, 2, 11, 6, 7
];

export const DEMO_DATA_DASHBOARD_POST_REACTIONS_LINKEDIN_PERSONAL_ACCOUNT = [
  5, 2, 2, 11, 7, 6, 3
];
export const DEMO_DATA_DASHBOARD_POST_REACTIONS_TWITTER = [1, 3, 2, 7, 4, 6, 6];
export const DEMO_DATA_DASHBOARD_POST_REACTIONS_INSTAGRAM = [
  14, 12, 13, 14, 16, 26, 33
];
export const DEMO_DATA_DASHBOARD_POST_REACTIONS_FACEBOOK = [
  0, 11, 14, 12, 0, 14, 18
];

export const DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_FACEBOOK = [
  0, 15, 20, 15, 0, 50, 80
];
export const DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_INSTAGRAM = [
  40, 40, 0, 10, 5, 0, 45
];
export const DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_LINKEDIN_BUSINESS_PAGE = [
  40, 0, 40, 20, 130, 60, 80
];

export const DEMO_DATA_FACEBOOK_GROWTH_REACTIONS = [0, 0, 1, 2, 3, 4, 7, 9];
export const DEMO_DATA_FACEBOOK_GROWTH_FOLLWERS = [
  0, 158, 160, 145, 166, 156, 175, 183
];
export const DEMO_DATA_FACEBOOK_GROWTH_IMPRESSIONS = [
  0, 140, 170, 190, 185, 200, 230, 290
];
export const DEMO_DATA_FACEBOOK_POST_IMPRESSIONS = [
  0, 7, 17, 22, 30, 30, 40, 80
];

export const DEMO_DATA_FACEBOOK_VIDEO_IMPRESSIONS = [
  0, 1, 6, 24, 35, 50, 65, 85
];
export const DEMO_DATA_FACEBOOK_ENGAGEMENET_REATIONS = [
  0, 1, 5, 7, 7, 9, 11, 13
];
export const DEMO_DATA_FACEBOOK_OVERVIEW_INTERACTION = [0, 0, 0, 5, 5, 5, 7, 7];

export const DEMO_DATA_FACEBOOK_OVERVIEW_IMPRESSION = [
  0, 10, 12, 18, 18, 24, 35, 40
];
export const DEMO_DATA_FACEBOOK_OVERVIEW_REACH = [0, 0, 10, 20, 40, 60, 75, 95];
export const DEMO_DATA_LINKEDIN_INTERACTIONS_SHARES = [0, 0, 0, 0, 0, 1, 1, 1];
export const DEMO_DATA_LINKEDIN_INTERACTIONS_REACTIONS = [
  0, 3, 4, 8, 10, 23, 26, 30
];
export const DEMO_DATA_LINKEDIN_SUMMARY_INTERACTIONS = [
  0, 0, 0, 0, 0, 30, 30, 30
];
export const DEMO_DATA_LINKEDIN_SUMMARY_IMPRESSIONS = [
  0, 45, 0, 45, 85, 240, 320, 389
];
export const DEMO_DATA_LINKEDIN_OVERVIEW_FOLLOWERS = [
  124, 124, 121, 126, 127, 130, 150, 152
];
export const DEMO_DATA_LINKEDIN_OVERVIEW_VIEWS = [0, 0, 0, 0, 0, 4, 4, 4];
export const DEMO_DATA_LINKEDIN_OVERVIEW_REACH = [
  32, 34, 29, 27, 39, 45, 41, 40
];
export const DEMO_DATA_INSTAGRAM_GROWTH_FOLLOWERS = [
  160, 165, 167, 167, 178, 180, 181
];

export const DEMO_DATA_INSTAGRAM_GROWTH_IMPRESSIONS = [
  0, 50, 40, 40, 60, 45, 50, 80
];
export const DEMO_DATA_INSTAGRAM_GROWTH_PROFILE_VIEWS = [
  0, 0, 0, 12, 12, 12, 19, 19
];
export const DEMO_DATA_INSTAGRAM_ENGAGEMENT_COMMENTS = [0, 0, 0, 0, 0, 0, 4, 4];
export const DEMO_DATA_INSTAGRAM_ENGAGEMENT_SHARES = [0, 0, 0, 0, 3, 3, 0, 0];
export const DEMO_DATA_INSTAGRAM_ENGAGEMENT_LIKES = [
  0, 4, 6, 21, 24, 30, 50, 60
];

export const DEMO_DATA_GOOGLE_REACH_MAPS = [0, 1, 0, 0, 0, 0, 0, 0];
export const DEMO_DATA_GOOGLE_REACH_SEARCH = [9, 5, 3, 0, 5, 1, 6, 0];
export const DEMO_DATA_GOOGLE_REACH_TOTAL = DEMO_DATA_GOOGLE_REACH_MAPS.map(
  (item, index) => item + DEMO_DATA_GOOGLE_REACH_SEARCH[index]
);
export const DEMO_DATA_GOOGLE_CLICKS_WEBSITE = [1, 2, 0, 4, 0, 3, 0, 2];
export const DEMO_DATA_GOOGLE_CLICKS_DIRECTIONS = [1, 0, 0, 0, 1, 2, 0, 0];
export const DEMO_DATA_GOOGLE_CLICKS_TOTAL =
  DEMO_DATA_GOOGLE_CLICKS_WEBSITE.map(
    (item, index) => item + DEMO_DATA_GOOGLE_CLICKS_DIRECTIONS[index]
  );
export const DEMO_DATA_DASHBOARD_FOLLOWERS_LINKEDIN_BUSINESS_PAGE = [
  153, 154, 154, 160, 162, 162, 163, 152
];
export const DEMO_DATA_DASHBOARD_FOLLOWERS_FACEBOOK_PAGE = [
  170, 170, 174, 174, 174, 180, 183, 183
];
export const DEMO_DATA_DASHBOARD_FOLLOWERS_INSTAGRAM = [
  180, 180, 180, 182, 175, 176, 180, 187
];
export const DEMO_DATA_DASHBOARD_FOLLOWERS_TWITTER = [
  210, 226, 226, 226, 226, 220, 230, 230
];
